import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearProduct from "@insite/client-framework/Store/Components/ProductSelector/Handlers/ClearProduct";
import reset from "@insite/client-framework/Store/Components/ProductSelector/Handlers/Reset";
import searchProducts from "@NA/Overrides/Store/Components/ProductSelector/Handlers/SearchProducts";
import setProduct from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import setUnitOfMeasure from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetUnitOfMeasure";
import { getProductSelector } from "@insite/client-framework/Store/Components/ProductSelector/ProductSelectorSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
import DynamicDropdown from "../DynamicDropdown/DynamicDropdown";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import React, { ChangeEvent, ReactNode, useEffect, useState, useRef } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import _ from "lodash";
import TextArea from "@insite/mobius/TextArea";
import AddMoreFields from "@NA/Icons/AddMoreFields";
import getColor from "@insite/mobius/utilities/getColor";
import ADIColors from "@NA/Utils/ADIColors";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { getProductByIdQucikSearch } from "@NA/Services/ProductAccessoriesService";

interface OwnProps {
    skipInventoryValidation?: boolean;
    denyFixedConfiguration?: boolean;
    selectButtonTitle?: string;
    productIsConfigurableMessage?: ReactNode;
    productIsUnavailableMessage?: ReactNode;
    customErrorMessage?: ReactNode;
    extendedStyles?: ProductSelectorStyles;
    setIsInputActive: (isInputActive: boolean) => void;
    callAddToOrder: boolean;
    setCallAddToOrder: (callAddToOrder: boolean) => void;
    handleErrorData: (errorData: any) => void;
    handleSearchData: (searchData: any) => void;
    onhandleTextAreaDataCount: (count: number, productList: any) => void;
    setIsActionDisable: Function;
    isAddtoCartCompleted: boolean;
    setIsInputEntered: Function;
    qucikOrderMode: string;
    handleSearchApiLoading: (value: any) => void;
    updateTextAreaChange: (value: any) => void;
}

const mapStateToProps = (state: ApplicationState) => {
    const { searchResults } = getProductSelector(state);
    return {
        searchResults,
        location: getLocation(state),
    };
};

const mapDispatchToProps = {
    searchProducts,
    setProduct,
    clearProduct,
    setUnitOfMeasure,
    reset,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductSelectorStyles {
    container?: GridContainerProps;
    searchGridItem?: GridItemProps;
    qtyGridItem?: GridItemProps;
    unitOfMeasureGridItem?: GridItemProps;
    copyPasteContainer?: GridItemProps;
    dropdownQtyContainer?: InjectableCss;
    buttonGridItem?: GridItemProps;
    addMoreGrid?: GridItemProps;
    addmoreField?: InjectableCss;
    unitOfMeasureSelect?: SelectPresentationProps;
    qtyTextField?: TextFieldPresentationProps;
    optionWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    productImage?: LazyImageProps;
    infoWrapper?: InjectableCss;
    innerHeading?: InjectableCss;
    copyPasteInnerHeading?: InjectableCss;
    textareaItem?: InjectableCss;
    autocompleteTitleText?: TypographyPresentationProps;
    autocompleteErpText?: TypographyPresentationProps;
    selectButton?: ButtonPresentationProps;
    searchDynamicDropdown?: DynamicDropdownPresentationProps;
}

export const productSelectorStyles: ProductSelectorStyles = {
    container: {
        gap: 10,
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
            padding-bottom: 24px;
            margin-bottom: 24px;
            margin-top: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 15px;
                    `,
                    css`
                        margin-top: 15px;
                    `,
                    css`
                        margin-top: 15px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    innerHeading: {
        css: css`
            font-size: 24px;
            line-height: 26px;
            font-weight: 900;
            font-style: normal;
            letter-spacing: normal;
            color: ${ADIColors.darkBlue1};
            border-bottom: 1px solid ${getColor("common.border")};
            padding-bottom: 15px;
            margin-top: 0;
            margin-bottom: 12px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 12px;
                        margin-bottom: 15px;
                    `,
                    css`
                        padding-bottom: 12px;
                        margin-bottom: 15px;
                    `,
                    css`
                        padding-bottom: 12px;
                        margin-bottom: 15px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    copyPasteInnerHeading: {
        css: css`
            font-size: 14px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: 16px;
            letter-spacing: normal;
            color: ${getColor("text.main")};
            padding-bottom: 8px;
            padding-top: 20px;
        `,
    },
    textareaItem: {
        css: css`
            width: 100%;
            height: 230px;
            font-size: 14px !important;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 18px;
            letter-spacing: normal;
            color: ${ADIColors.black};
            border-radius: 6px;
            border: solid 1px ${getColor("common.border")};
            padding: 20px 20px;
            margin-bottom: 0;
            resize: none;
            &:focus {
                box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                border-color: ${getColor("common.border")} !important;
                background-color: ${getColor("common.background")};
            }
        `,
    },
    searchGridItem: {
        css: css`
            flex-basis: 80%;
            max-width: 80%;
            div {
                div[class^="OverflowWrapper"] {
                    span[class^="IconWrapper"] {
                        display: none;
                    }
                }
            }
            ${FormInputWrapper} {
                z-index: unset !important;
            }
        `,
    },
    qtyGridItem: {
        css: css`
            flex-basis: 15%;
            max-width: 15%;
            align-items: end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    null,
                ])}
            div {
                input {
                    text-align: center;
                    -moz-appearance: textfield !important;
                }
            }
            > input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }
        `,
    },
    unitOfMeasureGridItem: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            display: block;
            padding-right: 80px;
            border-right: 1px solid ${getColor("common.border")};
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        padding-right: 5px;
                        border-right: 0;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        padding-right: 5px;
                        border-right: 0;
                    `,
                    css`
                        padding-right: 28px;
                        &::after {
                            content: "or";
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: absolute;
                            top: 50%;
                            right: -7px;
                            background: ${ADIColors.white};
                            height: 24px;
                            padding: 4px 0;
                            border-radius: 8px;
                        }
                    `,
                    css`
                        &::after {
                            content: "or";
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: absolute;
                            top: 50%;
                            right: -7px;
                            background: ${ADIColors.white};
                            height: 24px;
                            padding: 4px 0;
                            border-radius: 8px;
                        }
                    `,
                    css`
                        &::after {
                            content: "or";
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: absolute;
                            top: 50%;
                            right: -7px;
                            background: ${ADIColors.white};
                            height: 24px;
                            padding: 4px 0;
                            border-radius: 8px;
                        }
                    `,
                ])}
        `,
    },
    copyPasteContainer: {
        css: css`
            flex-basis: 50%;
            max-width: 50%;
            display: block;
            padding-left: 80px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        padding-left: 38px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    dropdownQtyContainer: {
        css: css`
            display: flex;
        `,
    },
    buttonGridItem: {
        width: [12, 12, 3, 3, 3],
    },
    addMoreGrid: {
        width: [12, 12, 3, 3, 3],
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    addmoreField: {
        css: css`
            border: none !important;
            background: none !important;
            padding-left: 10px;
            > span {
                color: ${getColor("text.link")} !important;
                font-size: 14px;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
            }
        `,
    },
    optionWrapper: {
        css: css`
            display: flex;
            cursor: pointer;
        `,
    },
    imageWrapper: {
        css: css`
            display: flex;
            width: 50px;
            height: 50px;
            margin-right: 10px;
        `,
    },
    productImage: {
        width: "50px",
        css: css`
            flex-shrink: 0;
            img {
                height: 100%;
            }
        `,
    },
    infoWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    autocompleteTitleText: {
        size: 14,
    },
    autocompleteErpText: {
        size: 14,
        css: css`
            margin-top: 5px;
        `,
    },
    selectButton: {
        css: css`
            margin-top: 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
};

const ENTER_KEY = 13;

interface DataType {
    productId: string;
    errorMessage: string;
    qty: string;
    minProductQty?: string;
    option: OptionObject[];
    searchTerm: string;
    id: string;
    selectedProduct?: any;
    erpNumber?: any;
    showAuthorizationRequired?: string;
    unitOfMeasure?: string;
}

const data: DataType[] = [
    {
        productId: "",
        errorMessage: "",
        qty: "",
        option: [],
        searchTerm: "",
        id: "1",
        erpNumber: "",
        showAuthorizationRequired: "false",
        unitOfMeasure: "",
    },
    {
        productId: "",
        errorMessage: "",
        qty: "",
        option: [],
        searchTerm: "",
        erpNumber: "",
        id: "2",
        showAuthorizationRequired: "false",
        unitOfMeasure: "",
    },
    {
        productId: "",
        errorMessage: "",
        qty: "",
        option: [],
        searchTerm: "",
        id: "3",
        erpNumber: "",
        showAuthorizationRequired: "false",
        unitOfMeasure: "",
    },
    {
        productId: "",
        errorMessage: "",
        qty: "",
        option: [],
        searchTerm: "",
        id: "4",
        erpNumber: "",
        showAuthorizationRequired: "false",
        unitOfMeasure: "",
    },
    {
        productId: "",
        errorMessage: "",
        qty: "",
        option: [],
        searchTerm: "",
        id: "5",
        erpNumber: "",
        showAuthorizationRequired: "false",
        unitOfMeasure: "",
    },
];

const ProductSelector = ({
    skipInventoryValidation,
    denyFixedConfiguration,
    searchProducts,
    searchResults,
    setProduct,
    extendedStyles,
    location,
    reset,
    setIsInputActive,
    setIsActionDisable,
    onhandleTextAreaDataCount,
    handleSearchData,
    isAddtoCartCompleted,
    setIsInputEntered,
    handleSearchApiLoading,
    updateTextAreaChange,
}: Props) => {
    const [searchArray, setSearchArray] = useState(data);
    const [activeId, setActiveId] = useState("1");
    const [textAreaArray, setTextAreaArray] = useState<any>([]);
    const [styles] = useState(() => mergeToNew(productSelectorStyles, extendedStyles));
    const [textAreaValue, setTextAreaValue] = useState("");
    useEffect(() => {
        let isSearchArrayActive = searchArray.some(item => item?.searchTerm);
        let isTextAreaArrayActive = textAreaArray.some((item: any) => item?.productId);
        if (isSearchArrayActive || isTextAreaArrayActive) {
            setIsInputActive(true);
        } else {
            setIsInputActive(false);
        }
        let searchTerm = false;
        const isAnyDataInInputSearchArray = searchArray.filter(item => item.searchTerm != "" || item.productId != "");
        if (isAnyDataInInputSearchArray.length > 0) {
            searchTerm = true;
        }
        if (textAreaArray.length > 0 && textAreaArray[0]?.productId !== "") {
            searchTerm = true;
        } else {
            searchTerm = false;
        }
        setIsActionDisable(searchTerm);
    }, [searchArray, textAreaArray]);

    useEffect(() => {
        if (isAddtoCartCompleted) {
            setSearchArray(prevSearchArray => {
                return prevSearchArray.map(item => {
                    return {
                        ...item,
                        option: [],
                        qty: "",
                        searchTerm: "",
                        selectedProduct: {},
                        productId: "",
                        erpNumber: "",
                        showAuthorizationRequired: "false",
                    };
                });
            });
            setTextAreaValue("");
            setTextAreaArray([]);
            updateTextAreaChange([])
            onhandleTextAreaDataCount(0, [])
        }
    }, [isAddtoCartCompleted]);

    useEffect(() => {
        reset();
    }, [location.pathname]);

    useEffect(() => {
        if (!searchResults) {
            return;
        }

        const newOptions = searchResults.map(product => ({
            optionText: product.title,
            optionValue: product.id || undefined,
            rowChildren: (
                <StyledWrapper {...styles.optionWrapper}>
                    <StyledWrapper {...styles.imageWrapper}>
                        <LazyImage {...styles.productImage} src={product.image} />
                    </StyledWrapper>
                    <StyledWrapper {...styles.infoWrapper}>
                        <Typography {...styles.autocompleteTitleText}>{product.displayTitle}</Typography>
                        <Typography {...styles.autocompleteErpText}>{product.displayErpNumber}</Typography>
                    </StyledWrapper>
                </StyledWrapper>
            ),
        }));
        if (activeId) {
            setSearchArray(searchArray => {
                return searchArray.map(item => {
                    if (item.id === activeId) {
                        return {
                            ...item,
                            option: newOptions,
                        };
                    }
                    return { ...item };
                });
            });
        }
    }, [searchResults, activeId]);

    useEffect(() => {
        if (searchArray && searchArray.length) {
            handleSearchData(searchArray);
        }
    }, [searchArray]);

    useEffect(() => {
        handleTextAreaSearchResults();
    }, [searchResults && searchResults[0]?.erpNumber]);

    const handleTextAreaSearchResults = debounce(() => {
        if (textAreaArray && searchResults) {
            for (let i = 0; i < textAreaArray.length; i++) {
                if (textAreaArray[i].productId === searchResults[0]?.erpNumber) {
                    textAreaChangeHandler(searchResults[0].id || "");
                }
            }
        }
    }, 100);

    const addInputFields = () => {
        let newArray: DataType[] = [];
        for (let i = 0; i < 5; i++) {
            newArray.push({
                productId: "",
                errorMessage: "",
                qty: "#",
                option: [],
                searchTerm: "",
                id: _.uniqueId("KEY_"),
                minProductQty: "0",
                erpNumber: "",
            });
        }
        setSearchArray(prevArray => [...prevArray, ...newArray]);
    };

    const textAreaChangeHandler = (value?: string) => {
        if (searchResults && searchResults.length > 0) {
            const variantParentId = searchResults.find(o => o.id === value)?.styleParentId;
            if (variantParentId) {
                setProduct({
                    productId: variantParentId,
                    variantId: value,
                    validateProduct: true,
                    skipInventoryValidation,
                    denyFixedConfiguration,
                    onComplete(result) {
                        if (result.product?.properties) {
                            // updateMinumQty(result.product?.properties["minimuM_QTY"], result.product?.id);
                        }
                    },
                });
            } else {
                setProduct({
                    productId: value,
                    validateProduct: true,
                    skipInventoryValidation,
                    denyFixedConfiguration,
                    onComplete(result) {
                        if (result.product?.properties) {
                            //updateMinumQty(result.product?.properties["minimuM_QTY"], result.product?.id);
                        }
                    },
                });
            }
        }
    };

    const updateMinumQty = (product: any) => {
        setSearchArray(searchArray => {
            return searchArray.map(item => {
                if (item.productId === product.id) {
                    return {
                        ...item,
                        qty: product?.properties["minimuM_QTY"],
                        minProductQty: product?.properties["minimuM_QTY"],
                        showAuthorizationRequired: product?.properties["showAuthorizationRequired"],
                        erpNumber: product?.erpNumber,
                        unitOfMeasure: product?.unitOfMeasure,
                        selectedProduct: product,
                    };
                }
                return { ...item };
            });
        });
    };

    const onSelectionChangeHandler = async (value: string, index: number) => {
        if (value) {
            handleSearchApiLoading(true);
            let updatedSearchArry = searchArray[index];
            updatedSearchArry.productId = value;
            searchArray[index] = updatedSearchArry;
            setSearchArray(searchArray);
            const result: any = await getProductByIdQucikSearch({
                id: value as string,
                expand: ["pricing", "brand", "styledproducts"],
            });
            handleSearchApiLoading(false);
            if (result && result.product) {
                updateMinumQty(result.product);
            }
        }
    };

    const debouncedSearchProducts = debounce((query: string) => {
        searchProducts({ query });
    }, 300);

    const handleQuantity = (value: string, id: string) => {
        setSearchArray(searchArray => {
            return searchArray.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        qty: value,
                    };
                }
                return { ...item };
            });
        });
    };

    const onInputChanged = (id: string, searchTerm: string, index: any) => {
        if(searchTerm.length >= 3){ // Added a condition on checking length is a P21 Change 
        setActiveId(id);
        setSearchArray(searchArray => {
            return searchArray.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        errorMessage: "",
                        searchTerm,
                    };
                }
                return { ...item };
            });
        });

        debouncedSearchProducts(searchTerm);
        setIsInputEntered({
            searchTerm,
            index,
        });
    }
    };

    const handleTextAreaChange = (searchTerm: string) => {
        debouncedSearchProducts(searchTerm);
    };

    const handleTextArea = (e: any) => {
        const textAreaValue = e.target.value;
        setTextAreaValue(textAreaValue);
        setIsActionDisable(false);
        const textAreaArray = textAreaValue.split(/\n+/);
        const productIdMap: { [key: string]: number } = {};
        // Process each line
        textAreaArray.forEach((line: any) => {
            // Split each line by commas and trim whitespace
            const parts = line.split(",").map((part: any) => part.trim());

            // Iterate over parts to handle productId and qtyOrdered pairs
            for (let i = 0; i < parts.length; i += 2) {
                const productId = parts[i];
                const qty = parseInt(parts[i + 1] || "1", 10);

                // Aggregate qtyOrdered for each productId
                if (productId) {
                    productIdMap[productId] = (productIdMap[productId] || 0) + (isNaN(qty) ? 1 : qty);
                }
            }
        });

        // Convert productIdMap to textAreaFormedArray
        const textAreaFormedArray: any[] = Object.keys(productIdMap).map(productId => ({
            productId,
            qtyOrdered: productIdMap[productId] == 0 ? 1 : productIdMap[productId],
        }));

        setTextAreaArray(textAreaFormedArray);
        onhandleTextAreaDataCount(textAreaFormedArray.length, textAreaFormedArray);
    };

    const onKeyPress = (event: React.KeyboardEvent) => {
        if (event.charCode === ENTER_KEY) {
        }
    };

    const handleOnBlurQty = () => {
        updateTextAreaChange(textAreaArray);
    };
    

    return (
        <GridContainer {...styles.container} data-test-selector="productSelector">
            <GridItem {...styles.unitOfMeasureGridItem}>
                <StyledWrapper as="h2" {...styles.innerHeading}>
                    Search and Select
                </StyledWrapper>
                <StyledWrapper>
                    Start typing an ADI or model number or name to search for the products you wish to order.
                </StyledWrapper>
                {searchArray.map((item, index) => {
                    return (
                        <StyledWrapper {...styles.dropdownQtyContainer} key={item.id}>
                            <GridItem {...styles.searchGridItem}>
                                <DynamicDropdown
                                    {...styles.searchDynamicDropdown}
                                    onSelectionChange={value => onSelectionChangeHandler(value as string, index)}
                                    onInputChange={e => onInputChanged(item.id, e.target.value, index)}
                                    onKeyPress={onKeyPress}
                                    filterOption={() => true}
                                    selected={item.productId}
                                    options={item.option}
                                    error={item.errorMessage}
                                    placeholder={item.id === "1" ? "Start searching here" : ""}
                                    data-test-selector="productSelector_search"
                                    isAddtoCartCompleted={isAddtoCartCompleted}
                                />
                            </GridItem>
                            <GridItem {...styles.qtyGridItem}>
                                <TextField
                                    type="number"
                                    min={0}
                                    max={999999} ////Quick Order Page - added max limit set for the Item qty- ADINA-52018 
                                    value={item.qty}
                                    onChange={e => {
                                        handleQuantity(e.currentTarget.value, item.id);
                                    }}
                                    placeholder="#"
                                    data-test-selector="productSelector_qty"
                                />
                            </GridItem>
                        </StyledWrapper>
                    );
                })}
            </GridItem>
            <GridItem {...styles.copyPasteContainer}>
                <StyledWrapper as="h2" {...styles.innerHeading}>
                    Copy and Paste
                </StyledWrapper>
                <StyledWrapper>
                    If you have a list of products and quantities, you can copy/paste it here. Item or product number
                    and quantity should be in the following format: AB123, 5
                </StyledWrapper>
                <StyledWrapper>
                    <StyledWrapper as="h3" {...styles.copyPasteInnerHeading}>
                        Item (or Product) Number, Quantity
                    </StyledWrapper>
                    <TextArea
                        {...styles.textareaItem}
                        id="CopyPaste"
                        name="CopyPaste"
                        rows={5}
                        cols={33}
                        value={textAreaValue}
                        placeholder="Item or product number, Quantity &#10;Item or product number, Quantity"
                        onChange={handleTextArea}
                        onBlur={handleOnBlurQty}
                    />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.addMoreGrid}>
                <AddMoreFields />
                <Button {...styles.addmoreField} onClick={addInputFields}>
                    Add More Fields
                </Button>
            </GridItem>
            <GridItem {...styles.buttonGridItem}></GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSelector);
